import Vue from 'vue'
import App from './App.vue'
import router from './router'

import './plugins/element.js'



import "./assets/css/global.css"
import './assets/style/index.scss'
import axios from "axios"

import global from "./assets/js/global"
import globalvar from "./assets/js/global-var"
import "./assets/icon/jk/iconfont.css"
// import 'babel-polyfill'
Vue.use(global);
// import VueTextareaAutosize from "vue-textarea-autosize";
// Vue.use(VueTextareaAutosize);
Vue.config.productionTip = false;
// axios.defaults.baseURL="http://119.3.188.100:90/api/"
// axios.defaults.baseURL2="http://119.3.188.100:90/"
axios.defaults.baseURL="http://8.209.103.3:90/api/"
axios.defaults.baseURL2="http://8.209.103.3:90/"
axios.interceptors.request.use(config=>{
  config.headers.token=localStorage.getItem("token")
  return config
})
Vue.prototype.$http=axios
Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

Vue.prototype.global=globalvar;
